import { useEffect, useState } from "react";
import { Button } from "shared/components";
import { useGlobalState } from "shared/contexts/Global";

export const SharingLinks = ({
  className,
  buttonClassName,
  appearance = "dark",
}) => {
  const { socialSharingLinks } = useGlobalState();
  const [currentUrl, setCurrentUrl] = useState(null);

  useEffect(() => {
    if (typeof window !== "undefined") {
      setCurrentUrl(window.location.href);
    }
  }, []);

  return (
    <nav className={className}>
      {socialSharingLinks.map(({ title, href, icon }) => {
        return (
          <Button
            key={`${title}_${href}_${icon}`}
            as="a"
            htmlAttributes={{
              href: `${href}${currentUrl}`,
              title,
              target: "_blank",
            }}
            icon={icon}
            className={buttonClassName}
            appearance="outlined"
            theme={appearance}
            hover={appearance === "dark" ? "fill" : "reverse"}
          />
        );
      })}
    </nav>
  );
};
